import { DefaultValue, selector, selectorFamily, } from 'recoil';
import { TriStateType } from '../../types';
export function valueSelector({ key, select, alwaysSelected, }) {
    return selector({
        key,
        get: ({ get }) => {
            const sections = get(select);
            if (sections.length > 0 && sections[0].selected === TriStateType.TRUE) {
                return sections[0].value;
            }
            return null;
        },
        set: ({ get, set }, value) => {
            const sections = get(select);
            set(select, sections.map((is) => ({
                ...is,
                value: value instanceof DefaultValue || value === null ? 0 : value,
                selected: alwaysSelected
                    ? TriStateType.TRUE
                    : value instanceof DefaultValue || value === null
                        ? TriStateType.FALSE
                        : TriStateType.TRUE,
            })));
        },
    });
}
export function valueSelectorFamily({ key, select, alwaysSelected }) {
    return selectorFamily({
        key,
        get: (params) => ({ get }) => {
            const section = get(select(params));
            if (section.selected === TriStateType.TRUE) {
                return section.value;
            }
            return null;
        },
        set: (params) => ({ get, set }, value) => {
            const section = get(select(params));
            set(select(params), {
                ...section,
                value: value instanceof DefaultValue || value === null ? 0 : value,
                selected: alwaysSelected
                    ? TriStateType.TRUE
                    : value instanceof DefaultValue || value === null
                        ? TriStateType.FALSE
                        : TriStateType.TRUE,
            });
        },
    });
}
